import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

export const MultiDropdownWrapper = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: ${pxToRem('36px')};
  box-shadow: 0 ${pxToRem('6px')} ${pxToRem('12px')} -${pxToRem('4px')} ${props => props.theme.colors.black.seven};
  border: solid ${pxToRem('2px')} #f0f0f0;
  background-color: ${props => props.theme.colors.white};
  justify-content: space-between;
  align-items: center;
  margin-right: ${pxToRem('30px')};
  padding: ${pxToRem('0px')} ${pxToRem('6px')} ${pxToRem('0px')}
    ${pxToRem('6px')};
  width: ${props => props.width && pxToRem(props.width)};
  height: ${props => props.height && pxToRem(props.height)};

  ${props =>
    props.showDropdowns === false &&
    css`
      width: ${pxToRem('72px')};
      height: ${pxToRem('72px')};
      border-radius: 50%;
      padding: ${pxToRem('0px')};
      justify-content: center;
    `};
`;

export const DropdownWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-grow: 2;
  & > div {
    height: ${pxToRem('56px')};
    border-radius: ${pxToRem('36px')};
    &:hover,
    &:active {
      background-color: ${props => props.theme.colors.blue.five};
    }
  }

  ${props =>
    props.maxWidthControls &&
    css`
      & > div {
        width: 28%;
      }
    `}
`;

export const IconWrapper = styled.div`
  border: none;
  border-radius: 50%;
  color: ${props => props.theme.colors.white};
  background: ${props => props.theme.colors.gradient.cta};
  font-size: ${pxToRem('30px')};
  width: ${pxToRem('56px')};
  height: ${pxToRem('56px')};
  display: grid;
  justify-content: center;
  align-items: center;

  :hover {
    cursor: pointer;
  }
`;

export const Divider = styled.span`
  width: ${pxToRem('1px')};
  height: ${pxToRem('40px')} !important;
  margin: ${pxToRem('8px')} ${pxToRem('2px')};
  border: solid ${pxToRem('1px')} #ececed;
`;
